import { render, staticRenderFns } from "./AcademyPublicEventCard.vue?vue&type=template&id=60f346e9&scoped=true"
import script from "./AcademyPublicEventCard.vue?vue&type=script&lang=js"
export * from "./AcademyPublicEventCard.vue?vue&type=script&lang=js"
import style0 from "./AcademyPublicEventCard.vue?vue&type=style&index=0&id=60f346e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f346e9",
  null
  
)

export default component.exports